import Dashboard from "../views/dashboard";
import MainLayout from "../layout"
// import Rounds from "../views/rounds/Rounds";
import CreateRound from "../views/startups/rounds/CreateRound";
import CustomControlsView from "../views/controls/CustomControlsView";
import Error404 from "../ui-components/Error404";
import MyForm from "../views/controls/MyForm";
import ViewRound from "../views/startups/rounds/ViewRound";
import WelcomeScreen from "../views/dashboard/WelcomeScreen";
import { Grid } from "@mui/material";
import ThemeBGWrapper from "../ui-components/ThemeBGWrapper";
import Reports from "../views/reports/Reports";
import ViewReport from "../views/reports/CreateReport";
import StartupDetail from '../views/startupDetail'
import Profile from "../views/Profile/Profile";
import UpdateProfile from "../views/Profile/UpdateProfile";
import UpdateStartupProfile from "../views/startups/updateProfile";
import ApplicationsListing from "../views/startup_applications";
import StartupsListing from "../views/startups";
import BackrrStartupsListing from "../views/backrr_startups";
import BackrrInvestorsListing from "../views/backrr_investors";
import ViewApplicationDetail from "views/startup_applications/viewDetails";
import ViewStartupDetail from "views/startups/viewDetails";
import OnboardingLayout from "layout/MainContent/OnboardingLayout";
import Cookies from "js-cookie";
import Portfolio from "views/portfolio/Portfolio";
import AddPortfolio from "views/portfolio/AddPortfolio";
import AddUser from "../views/settings/AddUser";
import AddStartupUser from "../views/startups/settings/AddUser"
import ViewSettingsInformation from "../views/settings/index";
import LogoutScreen from "views/pages/LogoutScreen";
import CreateReport from "views/startups/reports/CreateReport";
import EditPerformance from "views/startups/performance/EditPerformance";
import ClaimProfilePage from "views/onboarding/miscellaneous/ClaimProfilePage";
import PersonalDetails from "views/onboarding/miscellaneous/PersonalDetailsPopup";

const MainRoutes = {
    path: '',
    // element: <> />,
    children: [
        {
            path: '',
            element: <MainLayout />,
            children: [
                {
                    path: '/',
                    element: <Dashboard />
                    // element: <ApplicationsListing />
                },
                {
                    path: 'deal-flow',
                    children: [
                        {
                            path: '',
                            element: <ApplicationsListing />,
                        },
                        // {
                        //     path: 'create_round',
                        //     element: <CreateRound />,
                        //     children: [
                        //         {
                        //             path: '',
                        //         },
                        //         {
                        //             path: ':id',
                        //             // element: <CreateRound />
                        //         },
                        //     ]
                        // },
                        // {
                        //     path: 'edit_round/:id',
                        //     element: <CreateRound />
                        // },
                        // {
                        //     path: 'view-profile',
                        //     element: <ViewApplicationDetail />
                        // },
                        // {
                        //     path: 'view-round',
                        //     element: <ViewApplicationDetail />
                        // },
                        // {
                        //     path: 'view-documents',
                        //     element: <ViewApplicationDetail />
                        // },
                        // {
                        //     path: 'view-funding',
                        //     element: <ViewApplicationDetail />
                        // },
                        // {
                        //     path: 'view-reports',
                        //     element: <ViewApplicationDetail />
                        // },
                        // {
                        //     path: 'view-performance',
                        //     element: <ViewApplicationDetail />
                        // },
                        // {
                        //     path: 'view-feedback',
                        //     element: <ViewApplicationDetail />
                        // },
                        // {
                        //     path: 'view-notes',
                        //     element: <ViewApplicationDetail />
                        // },
                        {
                            path: ':tab',
                            element: <ViewApplicationDetail />
                        },
                        {
                            path: '*',
                            element: <ViewApplicationDetail />
                        },
                    ]
                },
                // {
                //     path: 'startups',
                //     children: [
                //         {
                //             path: '',
                //             element: <StartupsListing />,
                //         },
                //         {
                //             path: 'add',
                //             element: <UpdateStartupProfile />,
                //         },
                //         {
                //             path: 'edit',
                //             element: <UpdateStartupProfile />,
                //         },
                //         // {
                //         //     path: 'create_round',
                //         //     element: <CreateRound />,
                //         //     children: [
                //         //         {
                //         //             path: '',
                //         //         },
                //         //         {
                //         //             path: ':id',
                //         //             // element: <CreateRound />
                //         //         },
                //         //     ]
                //         // },
                //         // {
                //         //     path: 'edit_round/:id',
                //         //     element: <CreateRound />
                //         // },
                //         // {
                //         //     path: 'view-profile',
                //         //     element: <ViewStartupDetail />
                //         // },
                //         // {
                //         //     path: 'view-round',
                //         //     element: <ViewStartupDetail />
                //         // },
                //         // {
                //         //     path: 'view-documents',
                //         //     element: <ViewStartupDetail />
                //         // },
                //         // {
                //         //     path: 'view-reports',
                //         //     element: <ViewStartupDetail />
                //         // },
                //         // {
                //         //     path: 'view-performance',
                //         //     element: <ViewStartupDetail />
                //         // },
                //         // {
                //         //     path: 'view-feedback',
                //         //     element: <ViewStartupDetail />
                //         // },
                //         // {
                //         //     path: 'view-notes',
                //         //     element: <ViewStartupDetail />
                //         // },
                //         {
                //             path: 'reports/add-report',
                //             element: <CreateReport />
                //         },
                //         {
                //             path: 'reports/edit-report',
                //             element: <CreateReport />
                //         },
                //         {
                //             path: 'rounds/add-round',
                //             element: <CreateRound />
                //         },
                //         {
                //             path: 'rounds/edit-round',
                //             element: <CreateRound />
                //         },
                //         {
                //             path: "rounds/view",
                //             element: <ViewRound tabValue="view_details" />
                //         },
                //         {
                //             path: "rounds/view-investors",
                //             element: <ViewRound tabValue="round_investors" />
                //         },
                //         {
                //             path: "rounds/view-documents",
                //             element: <ViewRound tabValue="documents" />
                //         },
                //         {
                //             path: "performance/add-performance",
                //             element: <EditPerformance key={"Add Performance"} />
                //         },
                //         {
                //             path: "performance/edit-performance",
                //             element: <EditPerformance key={"Edit Performance"} />
                //         },
                //         {
                //             path: "users/add-user",
                //             element: <AddStartupUser key={"Add Startup User"} />
                //         },
                //         {
                //             path: "users/edit-user",
                //             element: <AddStartupUser key={"Edit Startup User"} />
                //         },
                //         {
                //             path: ':tab',
                //             element: <ViewStartupDetail />
                //         },
                //         {
                //             path: '*',
                //             element: <ViewStartupDetail />
                //         },
                //     ]
                // },
                // {
                //     path: 'profile',
                //     children: [
                //         {
                //             path: '',
                //             element: <Profile />,
                //         },
                //         {
                //             path: 'edit_profile',
                //             element: <UpdateProfile />
                //         },
                //         // {
                //         //     path: 'view/:id',
                //         //     element: <ViewRound />
                //         // },
                //     ]
                // },
                // {
                //     path: 'portfolio',
                //     children: [
                //         {
                //             path: '',
                //             element: <Portfolio />
                //         },
                //         {
                //             path: 'create_portfolio',
                //             element: <AddPortfolio />
                //         },
                //         {
                //             path: 'create_portfolio/:id',
                //             element: <AddPortfolio />
                //         }
                //     ]

                // },
                // {
                //     path: 'reports',
                //     children: [
                //         {
                //             path: '',
                //             element: <Reports />
                //         },
                //         {
                //             path: 'view',
                //             element: <ViewReport />
                //         },
                //         // {
                //         //     path: 'create_report',
                //         //     element: <CreateReport />,
                //         //     children: [
                //         //         {
                //         //             path: '',
                //         //         },
                //         //         {
                //         //             path: ':id',
                //         //             // element: <CreateReport />
                //         //         },
                //         //     ]
                //         // },
                //         // {
                //         //     path: 'edit_report/:id',
                //         //     element: <CreateReport />
                //         // }
                //         // ,
                //         // {
                //         //     path: 'view/:id',
                //         //     element: <ViewRound />
                //         // },
                //     ],
                // },
                // {
                //     path: "settings",
                //     children: [
                //         {
                //             path: "",
                //             element: <ViewSettingsInformation />
                //         },
                //         {
                //             path: "add-user",
                //             element: <AddStartupUser key={"Add Admin User"} />
                //         },
                //         {
                //             path: "edit-user",
                //             element: <AddStartupUser key={"Edit Admin User"} />
                //         },
                //         // {
                //         //     path: "add_user",
                //         //     element: <AddUser />
                //         // },
                //     ]
                // },
                {
                    path: '*',
                    element: <BackrrStartupsListing />
                },
            ]
        },
        // {
        //     path: 's',
        //     element: <StartupDetail />
        // },
        // {
        //     path: '/welcome',
        //     element: <OnboardingLayout> <WelcomeScreen /></OnboardingLayout>,
        // },
        // {
        //     path: "/logout",
        //     element: <LogoutScreen />
        // },
        // {
        //     path: '/activate-profile',
        //     element: <OnboardingLayout><ClaimProfilePage /></OnboardingLayout>,
        // },
    ]
};

export default MainRoutes;
